import React from "react";
import Select from "react-select";

const InputSelect = ({
  name,
  placeholder,
  options,
  value,
  onChange,
  label,
  relative,
  shouldScrollIntoView,
}) => {
  return (
    <div>
      {label && <p className="mb-1.5 text-xs text-monochrome-400">{label}</p>}
      <Select
        name={name}
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={onChange}
        components={{ IndicatorSeparator: () => null }}
        menuShouldScrollIntoView={shouldScrollIntoView}
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "0.5rem",
            borderColor: "#e6e6e6",
            padding: "0.25rem 0.125rem",
          }),
          menu: (base) => ({
            ...base,
            position: relative ? "relative" : "absolute",
          }),
        }}
      />
    </div>
  );
};

export default InputSelect;
